
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"#0D69D5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.107 7.98l-1.179-1.179-7.761 7.762v1.178h1.178l7.762-7.761zm1.178-1.179l1.179-1.178-1.179-1.179-1.178 1.179 1.178 1.178zm-8.25 10.607H2.5v-3.535L13.696 2.677a.833.833 0 011.178 0l2.357 2.357a.833.833 0 010 1.178L6.036 17.408z"}})])
          )
        }
      }
    